import { render, staticRenderFns } from "./WxMpDefaultDeviceManage.vue?vue&type=template&id=638e0c24&"
import script from "./WxMpDefaultDeviceManage.vue?vue&type=script&lang=js&"
export * from "./WxMpDefaultDeviceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports